export default "/assets/images/download-mila-app.webp?9fc0240a07c91cee79858a03379e702a";